import React from "react";
import style from "./custom-heading.module.css";

const HeadingPrimary = ({ children, className, styles, id }) => {
  return (
    <h1
      className={`${style.heading} ${style.headingPrimary} ${className}`}
      style={{ ...styles }}
      id={id}
    >
      {children}
    </h1>
  );
};

export default HeadingPrimary;
